import SmartLockApiCallerInstance from '../utils/SmartLockApiCallerInstance';
import { SMART_LOCK_API_ENDPOINTS } from '../URLConstants';

export const GetAllDevices = async (page, search, status, sortFilterValue) => {
  let url = `${SMART_LOCK_API_ENDPOINTS.DEVICE_URL}?page=${page}&limit=10&search=${search}&sortOrder=${sortFilterValue}`;

  if (status === 'online' || status === 'offline') {
    url += `&status=${status}`;
  }

  const response = await SmartLockApiCallerInstance.get(url);
  return response;
};

export const AddDeviceData = async (data) => {
  const response = await SmartLockApiCallerInstance.post(SMART_LOCK_API_ENDPOINTS.DEVICE_URL, data);
  return response;
};

export const BulkUploadDevice = async (data) => {
  const response = await SmartLockApiCallerInstance.post(
    SMART_LOCK_API_ENDPOINTS.BULK_CREATE_DEVICE,
    data
  );
  return response;
};

export const UpdateDeviceDataById = async (id, data) => {
  const response = await SmartLockApiCallerInstance.patch(
    `${SMART_LOCK_API_ENDPOINTS.DEVICE_URL}/${id}`,
    data
  );
  return response;
};

export const GetDeviceDetailById = async (id) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.DEVICE_URL}/${id}`
  );
  return response;
};

export const GetTripDataByDeviceId = async (deviceId, page, limit) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.TRIP_DATA_BY_DEVICE_ID}/${deviceId}?page=${page}&limit=${limit}`
  );
  return response;
};

export const GetAllDeviceList = async () => {
  const response = await SmartLockApiCallerInstance.get(SMART_LOCK_API_ENDPOINTS.ALL_DEVICE_DATA);
  return response;
};

export const DeleteDeviceById = async (id) => {
  const response = await SmartLockApiCallerInstance.delete(
    `${SMART_LOCK_API_ENDPOINTS.DEVICE_URL}/${id}`
  );
  return response;
};

export const UpdateDeviceToOrganization = async (data) => {
  const response = await SmartLockApiCallerInstance.put(
    SMART_LOCK_API_ENDPOINTS.UPDATE_ORGANIZATION,
    data
  );
  return response;
};

export const UpdateRfidCardDetail = async (id, data) => {
  const response = await SmartLockApiCallerInstance.patch(
    `${SMART_LOCK_API_ENDPOINTS.UPDATE_RFID_CARD}/${id}`,
    data
  );
  return response;
};

export const GetOdometerReading = async (id, startDate, endDate) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.DEVICE_ODOMETER}/${id}?page=1&limit=10&&startdate=${endDate}&enddate=${startDate}`
  );
  return response;
};

export const GetDeviceEventData = async (id, startDate, endDate, page, limit, event) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.DEVICE_EVENT}/${id}?page=${
      page
    }&limit=${limit}&startdate=${endDate}&enddate=${startDate}&type=${event}`
  );
  return response;
};

export const DeviceInventoryList = async () => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.DEVICE_INVENTORY}?page=1&limit=500`
  );
  return response;
};

export const GetRfidCardList = async (id) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.GET_RFID_CARD}/${id}`
  );
  return response;
};

export const DeviceActionCommands = async (command, data) => {
  const response = await SmartLockApiCallerInstance.post(
    `${SMART_LOCK_API_ENDPOINTS.DEVICE_ACTION}/${command}`,
    data
  );
  return response;
};

export const ExportDeviceReport = async (id, startDate, endDate, type) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.EXPORT_DEVICE_REPORT}/${id}?startdate=${endDate}&enddate=${startDate}&type=${type}`
  );
  return response;
};

export const GetRfidDetails = async (id, reqId, type) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.RFID_DETAIL}/${id}?requestId=${reqId}&type=${type}`
  );
  return response;
};
